export default __webpack_public_path__ + "static/media/progress-second.59c5bd4d.svg";